import * as React from "react";
const SvgLink = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill={props.color}
      d="m13.944 24.499-3.649 3.648c-.682.652-1.608 1.054-2.628 1.054s-1.946-.401-2.629-1.055l.001.001-1.189-1.188c-.672-.672-1.088-1.601-1.088-2.627s.416-1.955 1.088-2.627l7.733-7.733c.673-.672 1.602-1.088 2.628-1.088s1.955.416 2.628 1.088l1.191 1.189a1.338 1.338 0 0 0 1.89-1.89l-1.191-1.189c-1.156-1.154-2.752-1.868-4.514-1.868s-3.358.714-4.514 1.868l-7.733 7.733C.813 20.97.098 22.566.098 24.328s.714 3.358 1.87 4.513l1.189 1.188C4.312 31.185 5.908 31.9 7.671 31.9s3.359-.715 4.514-1.871l3.648-3.647a1.334 1.334 0 1 0-1.886-1.887z"
    />
    <path
      fill={props.color}
      d="m30.035 3.151-1.189-1.189C27.689.811 26.094.1 24.333.1s-3.356.711-4.514 1.863L15.946 5.83a1.333 1.333 0 0 0 1.886 1.884l3.866-3.866c.673-.671 1.602-1.086 2.627-1.086s1.954.415 2.627 1.087l1.191 1.191c.673.672 1.089 1.602 1.089 2.628s-.416 1.956-1.089 2.628l-7.733 7.733a3.68 3.68 0 0 1-2.619 1.089h-.01.001-.01a3.676 3.676 0 0 1-2.615-1.088 1.333 1.333 0 1 0-1.887 1.882l.001.001a6.316 6.316 0 0 0 4.491 1.867h.023-.001.022a6.32 6.32 0 0 0 4.491-1.866l7.734-7.734c1.156-1.155 1.871-2.751 1.871-4.514s-.715-3.359-1.871-4.514z"
    />
  </svg>
);
export default SvgLink;
